import React from "react";
import Logo from "../../assests/footerLogo.png";
import "./Footer.css";

const Footer = () => (
  <footer className="thas-footer">
    <div className="thas-footer-inner">
      <div className="thas-footer-top">
        <div className="thas-footer-brand">
          <a href="/#home" aria-label="THAS Ekonomi och Redovisning – till startsidan">
            <img src={Logo} alt="THAS Ekonomi och Redovisning" width="220" height="100" />
          </a>
          <p>Redovisning med ditt<br />företag i fokus.</p>
        </div>
        <nav className="thas-footer-nav" aria-label="Sidfotsmeny">
          <h2>Utforska</h2>
          <a href="/#services">Våra tjänster</a>
          <a href="/#priser">Priser & paket</a>
          <a href="/#about">Om oss</a>
          <a href="/blogg">Kunskap & guider</a>
          <a href="/#contact">Kontakta oss</a>
        </nav>
        <div className="thas-footer-contact">
          <h2>Hör av dig</h2>
          <a href="mailto:info@thas-redovisning.se">info@thas-redovisning.se</a>
          <a href="tel:+46760211685">+46 760211685</a>
          <p>Stockholm, Sverige</p>
        </div>
      </div>
      <div className="thas-footer-bottom">
        <p>© {new Date().getFullYear()} THAS Ekonomi och Redovisning AB</p>
        <a href="/#home">Till toppen <span aria-hidden="true">↑</span></a>
      </div>
    </div>
  </footer>
);

export default Footer;
